import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import { BannerResponse } from "./type";

export const BannerApi = {
  getBanner: () =>
    axiosRequest.post<BannerResponse>("", payloadHelper("Banner", "", null))
};
